export const routeErrorBoundaryStyles = {
  container: {
    backgroundColor: '#F7F5FB',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  content: {
    maxWidth: 610,
    width: '100%',
    padding: '40px 32px',
    textAlign: 'center',
    borderRadius: '24px',
  },

  title: {
    color: '#22223B',
    fontWeight: 600,
    mb: 4,
  },

  message: {
    color: '#6C6C80',
    fontSize: '1.2em',
    fontWeight: 600,
    mb: 4,
  },

  button: {
    background: 'linear-gradient(90deg, #B16CEA 0%, #5F61E6 100%)',
    color: '#fff',
    fontWeight: 600,
    border: 'none',
    borderRadius: '24px',
    width: '40%',
  },
};
